/**
 * @desc 编辑sku仓库包装信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlmSkuWarehousePackageRootRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/editSkuWarehousePackage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
